import React from "react";
import { useAppSelector } from "../../../../hooks";
import { Typography, Box } from "@mui/material";
import { Visibility } from "@mui/icons-material";

const NoteSection = () => {
  const { selectedCartItem, cartMode, selectedSession } = useAppSelector(
    (state) => state.cart
  );

  if (
    (cartMode == "pickup" && selectedSession?.cartItems[0]?.note == null) ||
    selectedSession?.cartItems == null
  ) {
    return null;
  }

  return (
    <Box
      border={1}
      borderColor="grey.400"
      borderRadius={2}
      p={2}
      sx={{ visibility: selectedCartItem == null ? "hidden" : "visible" }}
    >
      <Typography variant="subtitle1" fontWeight={500}>
        Note
      </Typography>
      <Typography variant="body1">{selectedCartItem?.note || "all"}</Typography>
    </Box>
  );
};

export default NoteSection;
